import Home from 'carbon-icons-svelte/lib/Home.svelte';
import Cloud from 'carbon-icons-svelte/lib/Cloud.svelte';
import Plane from 'carbon-icons-svelte/lib/Plane.svelte';

export default {
  'surface': Home,
  'cloud': Cloud,
  'cruise': Plane,
  '500 mb': Cloud,
  '200 mb': Plane,
};
